import styled from 'styled-components';

export const NotificationDropdownWrapper = styled.div`
  background: #0B0F1B;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.4);
  min-width: 360px;
  max-width: 420px;
  max-height: 500px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const NotificationHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background: #0B0F1B;

  h4 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #FFFFFF;
    letter-spacing: -0.02em;
  }
`;

export const Badge = styled.span`
  background: #007AFF;
  color: white;
  border-radius: 16px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 600;
  min-width: 24px;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 122, 255, 0.3);
`;

export const NotificationContent = styled.div`
  flex: 1;
  overflow-y: auto;
  max-height: 420px;
  background: #0B0F1B;

  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #007AFF;
    border-radius: 8px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #0056CC;
  }
`;

export const NotificationItem = styled.div<{ isRead: boolean }>`
  padding: 18px 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  cursor: pointer;
  transition: all 0.2s ease;
  background: ${props => props.isRead ? '#0B0F1B' : 'rgba(0, 122, 255, 0.05)'};
  position: relative;

  &:hover {
    background: rgba(0, 122, 255, 0.1);
  }

  &:last-child {
    border-bottom: none;
  }

  ${props => !props.isRead && `
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 3px;
      height: 70%;
      background: #007AFF;
      border-radius: 0 2px 2px 0;
    }
  `}
`;

export const NotificationActions = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 14px;
  justify-content: flex-end;
  
  .ant-btn {
    font-size: 12px;
    height: 28px;
    border-radius: 6px;
    font-weight: 500;
    
    &:hover {
      transform: translateY(-1px);
    }
  }
`;
